import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AccessDenied() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-20">
      <div className="card p-10 text-center max-w-md">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-50 flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0110 0v4" />
          </svg>
        </div>
        <h1 className="text-lg font-bold text-gray-800 mb-2">Access Denied</h1>
        <p className="text-sm text-gray-500 mb-6">
          You do not have permission to access this page. Contact your system administrator if you believe this is an error.
        </p>
        <button
          onClick={() => navigate('/')}
          className="btn-primary"
        >
          ← Back to Dashboard
        </button>
      </div>
    </div>
  );
}
